import { render, staticRenderFns } from "./DeclineReasons.vue?vue&type=template&id=51733c41"
import script from "./DeclineReasons.vue?vue&type=script&lang=js"
export * from "./DeclineReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports